import React from "react";
import Container from "./Container";
import Reveal from "./Reveal";

export default function Section({
  id,
  className = "",
  containerClassName = "",
  eyebrow,
  title,
  subtitle,
  children,
}) {
  return (
    <section id={id} className={`py-16 sm:py-20 ${className}`}>
      <Container className={containerClassName}>
        {(eyebrow || title || subtitle) && (
          <Reveal>
            <header className="mx-auto max-w-3xl text-center">
              {eyebrow ? (
                <div className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-fk-muted dark:text-gray-300">
                  {eyebrow}
                </div>
              ) : null}
              {title ? (
                <h2 className="text-balance text-3xl font-semibold tracking-tight text-fk-ink dark:text-gray-100 sm:text-4xl">
                  {title}
                </h2>
              ) : null}
              {subtitle ? (
                <p className="mt-4 text-pretty text-base leading-relaxed text-fk-muted dark:text-gray-300 sm:text-lg sm:leading-relaxed">
                  {subtitle}
                </p>
              ) : null}
            </header>
          </Reveal>
        )}
        {children}
      </Container>
    </section>
  );
}

